var ol = require('openlayers');
var PKK5ArcGISTileGrid = require('./PKK5ArcGISTileGrid');

function tileUrlFunction(tileCoord, pixelRatio, projection) {
    var tileGrid = this.getTileGrid();
    if (!tileGrid) {
        tileGrid = this.getTileGridForProjection(projection);
    }

    if (tileGrid.getResolutions().length <= tileCoord[0]) {
        return undefined;
    }

    var tileExtent = tileGrid.getTileCoordExtent(
        tileCoord/*, this.tmpExtent_*/);
    var tileSize = ol.size.toSize(
        tileGrid.getTileSize(tileCoord[0]), this.tmpSize);

    // if (pixelRatio != 1) {
    //     tileSize = ol.size.scale(tileSize, pixelRatio, this.tmpSize);
    // }

    // Apply default params and override with user specified values.
    // убрал их в getRequestUrl_ для удобства
    var baseParams = {};
    ol.obj.assign(baseParams, this.params_);

    return this.getRequestUrl_(tileCoord, tileSize, tileExtent,
        pixelRatio, projection, baseParams);
}

ol.source.PKK5ArcGISSource = function(opt_options){
    var options = opt_options || {};
    options = ol.obj.assign({}, options, {
        'tileUrlFunction': tileUrlFunction,
        'tileGrid': options['tileGrid'] || (
            new ol.tilegrid.PKK5ArcGISTileGrid()
        )
    });
    ol.source.TileArcGISRest.call(this, options);
};

ol.inherits(ol.source.PKK5ArcGISSource, ol.source.TileArcGISRest);

ol.source.PKK5ArcGISSource.prototype.calculatePKK5Extent = function(tileCoord, tileSize) {
    var tileGrid = this.getTileGrid();
    var s = tileGrid.getOrigin()[0],
        a = tileGrid.getOrigin()[1];

    var t = tileCoord[0]; // z
    var i = tileCoord[1]; // x
    var e = Math.abs(tileCoord[2]) -1; // y

    // t - zoom
    // e - колонка тайла в DOM
    // i - ряд тайла в DOM
    // s и a что-то скорее всего связанное с экстентом на 1 или 0 зуме.
    //      они всегда равны (s = -20037508.342787, a = 20037508.342787)

    var resolution = tileGrid.getResolution(t);
    var width = tileSize[0];
    var height = tileSize[1];
    var extent = {};
    extent.xmin = i * width * resolution + s;
    extent.ymin = a - (e + 1) * height * resolution;
    extent.ymax = a - e * height * resolution;
    extent.xmax = (i + 1) * width * resolution + s;
    // extent.spatialReference = this.spatialReference;
    return [extent.xmin, extent.ymin, extent.xmax, extent.ymax];
},

ol.source.PKK5ArcGISSource.prototype.getRequestUrl_ = function(
    tileCoord, tileSize, tileExtent,
    pixelRatio, projection, params
) {
    var urls = this.urls;
    var tileGrid = this.getTileGrid();

    if (!urls) {
        return undefined;
    }

    var layers = 'show:0,1,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,23,24,29,30,31,32,33,34,35,38,39';

    var srid = projection.getCode().split(':').pop();

    // поменял параметры в lowerCase
    params['layers'] = layers;
    params['dpi'] = 96;
    params['format'] = 'PNG32';
    // params['bbox'] = tileExtent.join(',');
    params['bbox'] = this.calculatePKK5Extent(tileCoord, tileSize).join(',');
    params['bboxSR'] = /*srid*/ '102100';
    params['imageSR'] = /*srid*/ '102100';
    params['size'] = tileSize[0] + ',' + tileSize[1];
    params['transparent'] = true;
    params['f'] = 'image';
    // params['dpi'] = Math.round(
    //         params['dpi'] ? params['dpi'] * pixelRatio : 90 * pixelRatio
    // );

    var url;
    if (urls.length == 1) {
        url = urls[0];
    } else {
        var index = ol.math.modulo(ol.tilecoord.hash(tileCoord), urls.length);
        url = urls[index];
    }

    var modifiedUrl = url
            .replace(/MapServer\/?$/, 'MapServer/export')
            .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
    return ol.uri.appendParams(modifiedUrl, params);
};

module.exports = ol.source.PKK5ArcGISSource;


//////////////////
// WEBPACK FOOTER
// ./src/View/PKK5ArcGISSource.js
// module id = 32
// module chunks = 0